<template>
  <div class="the-navbar__user-meta flex items-center">
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer"
    >
      <!-- Contenedor que agrupa el texto "Enlaces" y el ícono -->
      <div class="flex items-center">
        <div class="text-right leading-tight hidden sm:block">
          <p class="font-semibold mb-0">Enlaces</p>
        </div>

        <div class="con-img ml-3">
          <feather-icon icon="HelpCircleIcon" class="top--1 cursor-pointer mt-1 pr-5" />
        </div>
      </div>

      <!-- Menú desplegable -->
      <vs-dropdown-menu class="vx-navbar-dropdown company-dropdown menu-link">
        <ul style="min-width: 9rem" class="link-menu">
          <li class="flex py-2 px-4 text-center">
            <span class="ml-2 text-primary text-center">Centro de conocimiento</span>
          </li>
          <a target="_blank" href="https://verificamex.com/agendar-llamada">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="CalendarIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Agendar una llamada</span>
            </li>
          </a>
          <a target="_blank" href="https://ayuda.verificamex.com/collection/6-faq/">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">FAQ</span>
            </li>
          </a>
          <a href="https://verificamex.com/contacto">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="AlertCircleIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Solicitar Soporte</span>
            </li>
          </a>
          <a href="https://www.youtube.com/@verificamex" target="_blank">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="YoutubeIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Tutoriales (YouTube)</span>
            </li>
          </a>
          <a href="https://blog.verificamex.com/" target="_blank">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="BookOpenIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Blog de Verificamex</span>
            </li>
          </a>

        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

  </div>
</template>

<script>

  import Cookies from 'js-cookie';

  export default {
    methods: {
      startTour() {
        Cookies.set('skipTour', false);
        window.location = "/";
      }
    }
  }

</script>

<style lang="scss">
.link-menu{
  a{
    color: #636363!important;
  }
  li:hover{
    a{
      color: #fff!important;

    }
  }
}


.menu-link {
    .vs-dropdown--menu--after {
      right: 19px!important;
    }
}

.top--1{
  margin-top: -1px!important;
}
</style>
